import { ILoggingService } from './loggingService';
import { Howl } from 'howler';

export enum SoundType {
    Goal,
    EndTennis,
    EndOther,
    CouponWin
}

export interface ISoundService {
    playSound(soundType: SoundType): void;
    setIsMute(isMute: boolean): void;
}

/**
 * Creates sound services, e.g. in Chrome it plays sound after user "does something" in UI. Is it correct or lazy init is necessary?
 *
 * @param loggingService
 * @param soundFilesBaseUrl
 */
export function createSoundService(loggingService: ILoggingService, soundFilesBaseUrl: string): ISoundService {

    let isMute = true;

    let initCalled = false;
    let soundCouponWin: any = null;
    let soundGoal: any = null;

    const playSound = (soundType: SoundType): void => {
        loggingService.info("play " + soundType + ", mute " + isMute);
        if (isMute) {
            return;
        }

        if (soundType == SoundType.Goal) {
            if (soundGoal) {
                soundGoal.play();
            }
            return;
        }
        if (soundType == SoundType.CouponWin) {
            if (soundCouponWin) {
                soundCouponWin.play();
            }
            return;
        }
    }

    const setIsMute = (isMute_: boolean): void => {
        isMute = isMute_;
        if (!isMute && !initCalled) {
            initCalled = true;
            initSounds();
        }
    }

    const initSounds = (): void => {
        try {
            soundCouponWin = new Howl({
                src: [soundFilesBaseUrl + "/coupon_win.mp3", soundFilesBaseUrl + "/coupon_win.ogg"],
                volume: 0.5,
                autoplay: false
            });
        } catch (e) {
            loggingService.error(e);
        }

        try {
            soundGoal = new Howl({
                src: [soundFilesBaseUrl + "/goal.mp3", soundFilesBaseUrl + "/goal.ogg"],
                volume: 0.5,
                autoplay: false
            });
        } catch (e) {
            loggingService.error(e);
        }
    }

    return {
        playSound,
        setIsMute
    }
}

export function createDummySoundService(): ISoundService {

    return {
        playSound: () => { },
        setIsMute: () => { }
    }

}
